import { useContext } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import PricingCards from "./PricingCards";
import { Modal } from "../DesignSystem";

const PricingPlansDialog = () => {
    const { isPricingPlansDialogOpen, setIsPricingPlansDialogOpen } = useContext(LayoutContext);

    return (
        <div>
            <Modal
                open={isPricingPlansDialogOpen}
                onClose={() => setIsPricingPlansDialogOpen(false)}
                className="w-[90vw] px-0 sm:max-w-fit sm:p-6 sm:px-0 md:max-w-fit lg:max-w-[1100px]"
            >
                <div className="mt-2 max-h-[80dvh] overflow-y-auto px-6">
                    <PricingCards />
                </div>
            </Modal>
        </div>
    );
};

export default PricingPlansDialog;
